import { render } from "./LockingsComponent.vue?vue&type=template&id=c8c34866"
import script from "./LockingsComponent.vue?vue&type=script&lang=js"
export * from "./LockingsComponent.vue?vue&type=script&lang=js"

import "./LockingsComponent.vue?vue&type=style&index=0&id=c8c34866&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__